<template>
  <div>
    <a-form
      class="simiot-nested-search-form"
      :form="form"
      @submit="handleSearch"
    >
      <a-row :gutter="24">
        <a-col :xl="8" :xxl="6">
          <a-form-item label="客户名称">
            <a-input
              v-decorator="['agent_name', { normalize: this.$lodash.trim }]"
              allow-clear
            />
          </a-form-item>
        </a-col>

        <a-col :xl="8" :xxl="6">
          <a-form-item label="收付款类型">
            <a-select
              v-decorator="['transfer_type']"
              allow-clear
            >
              <a-select-option
                v-for="option in transferTypeOptions"
                :key="option.value"
                :value="option.value"
              >
                {{ option.label }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>

        <a-col :xl="8" :xxl="6">
          <a-form-item label="支付方式">
            <a-select
              v-decorator="['pay_way']"
              :loading="loadingPayWayOptions"
              allow-clear
              @focus="fetchPayWayOptions"
            >
              <a-select-option
                v-for="option in payWayOptions"
                :key="option.slug"
                :value="option.slug"
              >
                {{ option.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>

        <a-col :xl="8" :xxl="6">
          <a-form-item label="收付款日期">
            <a-range-picker
              v-decorator="['paid_at']"
              style="width: 100%;"
              allow-clear
            />
          </a-form-item>
        </a-col>

        <a-col :xl="8" :xxl="6">
          <a-form-item label="事件批次">
            <a-input
              v-decorator="['no', { normalize: this.$lodash.trim }]"
              allow-clear
            />
          </a-form-item>
        </a-col>

        <a-col :span="24" :xxl="12">
          <a-form-item>
            <a-space>
              <a-button type="primary" html-type="submit">
                搜索
              </a-button>
              <a-button @click="handleReset">
                刷新
              </a-button>
            </a-space>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </div>
</template>

<script>
import { formatRangeBeginDate, formatRangeEndDate } from '@/utils/time'
import { findTransferPayWayOptions } from '@/api/transfer'
import { findFinanceLedgerTransferTypeOptions } from '@/api/finance_ledger'

export default {
  name: 'SearchFinanceLedgerTransfers',
  data() {
    return {
      form: this.$form.createForm(this),
      transferTypeOptions: findFinanceLedgerTransferTypeOptions(),
      payWayOptions: [],
      loadingPayWayOptions: false
    }
  },
  methods: {
    fetchPayWayOptions() {
      if (this.payWayOptions.length > 0) {
        return
      }
      this.loadingPayWayOptions = true
      findTransferPayWayOptions().then((res) => {
        if (res.code === 0) {
          this.payWayOptions = res.data
        }
        this.loadingPayWayOptions = false
      })
    },

    handleSearch(e) {
      e.preventDefault()
      const fieldsValue = this.form.getFieldsValue()
      const values = {
        ...fieldsValue,
        paid_at_begin: formatRangeBeginDate(fieldsValue.paid_at),
        paid_at_end: formatRangeEndDate(fieldsValue.paid_at)
      }
      delete values.paid_at
      this.$emit('submit', values)
    },

    handleReset() {
      this.form.resetFields()
      this.$emit('submit', {})
    }
  }
}
</script>
